import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { INotification } from '@overtur-monorepo/notification-management'
import { KeyingAppEnvironmentConfig } from '../configuration/keying.app.environment.config'

export interface ICreateNotificationRequest {
  title: string
  content: string
  type: string
}

export interface IUpdateNotificationRequest {
  title: string
  content: string
  type: string
  sendNotification: boolean
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private get baseUrl(): string {
    return `${this.config.getBaseUrl()}/Notifications`
  }

  constructor(
    private http: HttpClient,
    private config: KeyingAppEnvironmentConfig,
  ) {}

  getAll(): Observable<INotification[]> {
    return this.http.get<INotification[]>(this.baseUrl)
  }

  create(payload: ICreateNotificationRequest): Observable<INotification> {
    return this.http.post<INotification>(this.baseUrl, payload)
  }

  update(id: number, payload: IUpdateNotificationRequest): Observable<INotification> {
    return this.http.put<INotification>(`${this.baseUrl}/${id}`, payload)
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
  }

  getPending(): Observable<INotification[]> {
    return this.http.get<INotification[]>(`${this.baseUrl}/pending`)
  }

  dismiss(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/dismiss`, {})
  }
}
